import { ReferenceLink } from "../components/article/ReferenceBox";

export const topics = {
    BOOK: "book",
    SOCIETY: "society",
    FOOD: "food",
    ETHICS: "ethics",
    SUSTAINABILITY: "sustainability",
    RAMBLE: "discourse",
    FUTURE: "future",
    TECHNOLOGY: "technology",
    TRAVEL: "travel",
    NATURE: "nature",
    PARENTHOOD: "parenthood"
};

export const supplements = {
    ALGORITHMS_TO_LIVE_BY: new ReferenceLink("Algorithms to Live By, Brian Christian and Tom Griffiths", "https://www.goodreads.com/book/show/25666050-algorithms-to-live-by"),
    HACKERS_AND_PAINTERS: new ReferenceLink("Hackers and Painters, Paul Graham", "http://www.paulgraham.com/hackpaint.html"),
    DATA_INTENSIVE_APPLICATIONS: new ReferenceLink("Designing Data-Intensive Applications, Martin Kleppmann", "https://dataintensive.net/"),
    ARTASHASTRA: new ReferenceLink("Artashastra, Kautilya", "https://en.wikipedia.org/wiki/Arthashastra"),
    NATURE_CARBON_CALCULATOR: new ReferenceLink("Nature.org Carbon Footprint Calculator", "https://www.nature.org/en-us/get-involved/how-to-help/carbon-footprint-calculator/"),
    LET_MY_PEOPLE_GO_SURFING_CHOUINARD: new ReferenceLink("Let My People Go Surfing, Yvon Chouinard", "https://www.goodreads.com/book/show/22155.Let_My_People_Go_Surfing"),
    THINKING_FAST_AND_FLOW: new ReferenceLink("Thinking, Fast and Slow, Daniel Kahneman", "https://www.goodreads.com/book/show/11468377-thinking-fast-and-slow"),
    SAPIENS_HARARI: new ReferenceLink("Sapiens, Yuval Noah Harari", "https://www.goodreads.com/book/show/23692271-sapiens"),
    SELFISH_GENE_DAWKINS: new ReferenceLink("Selfish Gene, Richard Dawkins", "https://www.goodreads.com/book/show/61535.The_Selfish_Gene"),
    INNOVATORS_ISAACSON: new ReferenceLink("The Innovators, Walter Isaacson", "https://en.wikipedia.org/wiki/The_Innovators_(book)"),
    EIGHTY_THOUSAND_HOURS: new ReferenceLink("80000 Hours - Key Ideas", "https://80000hours.org/key-ideas/"),
    WAIT_BUT_WHY_CAREER: new ReferenceLink("Wait But Why - 80000 Hours", "https://waitbutwhy.com/2018/04/picking-career.html"),
    FARNAM_STREET_MAKERS_MANAGERS: new ReferenceLink("Farnam Street: Makers vs. Managers", "https://fs.blog/maker-vs-manager/"),
    SUMMARY_DEEP_WORK_NEWPORT: new ReferenceLink("Summary of Deep Work, Cal Newport", "https://whatisthebusinessmodelof.com/business-books/deep-work-book-summary/"),
    CIVIL_DISOBEDIENCE: new ReferenceLink("Civil Disobedience, Stanford Encylopedia of Philosophy", "https://plato.stanford.edu/entries/civil-disobedience/"),
    MEANING_CRISIS: new ReferenceLink("Meaning Crisis", "https://www.meaningcrisis.co/all-transcripts/"),
    GODS_POWER_FROM_BELIEF: new ReferenceLink("The Gods Only Have Power Because We Believe In Them, Scott Alexander", "https://astralcodexten.substack.com/p/the-gods-only-have-power-because?s=r"),
    POWER_OF_MYTH: new ReferenceLink("Power of Myth, Joseph Campbell", "https://billmoyers.com/content/ep-6-joseph-campbell-and-the-power-of-myth-masks-of-eternity-audio/"),
    CAVE_FORGOTTEN_DREAMS: new ReferenceLink("Cave of Forgotten Dreams, Werner Herzog", "https://en.wikipedia.org/wiki/Cave_of_Forgotten_Dreams"),
    GRABBY_ALIENS: new ReferenceLink("Grabby Aliens", "https://grabbyaliens.com/"),
    SUPERFORECASTING: new ReferenceLink("Superforecasting", "https://en.wikipedia.org/wiki/Superforecasting:_The_Art_and_Science_of_Prediction"),
    HAPPINESS_LAB: new ReferenceLink("Happiness Lab", "https://www.happinesslab.fm/"),
    NAVAL_HAPPINESS: new ReferenceLink("Naval on Happiness", "https://nav.al/happiness"),
    THE_PRECIPICE: new ReferenceLink("The Precipice, Tony Ord", "https://theprecipice.com/"),
    YAHGAN_PEOPLE: new ReferenceLink("Yahgan People", "https://en.wikipedia.org/wiki/Yahgan_people"),
    MOXIE_MARLINSPIKE_HOLD_FAST: new ReferenceLink("Moxie Marlinspike - Hold Fast", "https://vimeo.com/15351476"),
    SEMI_SUPERVISED_LEARNING_EMR: new ReferenceLink("Semi-Supervised Approaches to Efficient Evaluation of Model Prediction Performance", "https://arxiv.org/pdf/1711.05663.pdf"),
    MERCHANT_OF_LANDSCAPES: new ReferenceLink("‘Merchant of Landscapes’: The Lasting Footprint of a Japanese Gardener in Mexico", "https://web.archive.org/web/20230325130727/https://www.nytimes.com/2023/03/25/world/americas/mexico-city-jacarandas.html"),
    CHALLENGE_VALUE_ALIGNMENT: new ReferenceLink("The Challenge of Value Alignment: from Fairer Algorithms to AI Safety", "https://arxiv.org/pdf/2101.06060.pdf"),
    CHALLENGES_OF_AI_REGULATION: new ReferenceLink("The Challenges of Regulating Artificial Intelligence", "https://www.brookings.edu/articles/the-three-challenges-of-ai-regulation/"),
    NEW_COMERS_GUIDE_TO_AI_RISK: new ReferenceLink("A Newcomer’s Guide to AI Risk", "https://www.lesswrong.com/posts/5rsa37pBjo4Cf9fkE/a-newcomer-s-guide-to-the-technical-ai-safety-field"),
    CAMPFIRE_BASICS: new ReferenceLink("Campfire Basics", "https://www.rei.com/learn/expert-advice/campfire-basics.html"),
    COLD_PLUNGES_BRAIN_ACTIVITY: new ReferenceLink("Cold Plunges and Brain Activity", "https://news.ycombinator.com/item?id=38284196"),
    LITTLE_BOOKS_OF_NATURE: new ReferenceLink("Little Books of Nature", "https://press.princeton.edu/series/little-books-of-nature"),
    AI_ALIGNMENT_HIGH_LEVEL: new ReferenceLink("What is AI Alignment?", "https://aisafetyfundamentals.com/blog/what-is-ai-alignment/"),
    BIRDSEYE_VIEW_ALIGNMENT: new ReferenceLink("A bird's-eye view of AI alignment", "https://www.alignmentforum.org/posts/SQ9cZtfrzDJmw9A2m/my-overview-of-the-ai-alignment-landscape-a-bird-s-eye-view/"),
    INTRO_TO_MECHANISTIC_INTERP: new ReferenceLink("Introduction to Mechanistic Interpretability", "https://aisafetyfundamentals.com/blog/introduction-to-mechanistic-interpretability/"),
    TRANSFORMERS_CIRCUITS: new ReferenceLink("Transformers Circuits (Anthropic)", "https://transformer-circuits.pub/"),
    FALL_OF_ROME: new ReferenceLink("The Fall of Rome", "https://en.wikipedia.org/wiki/Fall_of_the_Western_Roman_Empire"),
    ARTICLES_OF_CONFEDERATION: new ReferenceLink("Articles of Confederation", "https://en.wikipedia.org/wiki/Articles_of_Confederation"),
    PG_MAKER_MANAGER: new ReferenceLink("Maker's Schedule, Manager's Schedule", "https://www.paulgraham.com/makersschedule.html"),
    ANXIOUS_GENERATION: new ReferenceLink("The Anxious Generation", "https://archive.is/rAdgo"),
    SORT_BY_CONTROVERSIAL: new ReferenceLink("Sort by Controversial", "https://slatestarcodex.com/2018/10/30/sort-by-controversial/"),
    REASONING_MODELS_THINK: new ReferenceLink("Reasoning Models Don't Always Say What They Think", "https://arxiv.org/pdf/2505.05410"),
    HOW_TO_CATCH_A_LIAR: new ReferenceLink("How To Catch an AI Liar: Lie Detection In Black-Box LLMs by Asking Unrelated Questions", "https://arxiv.org/pdf/2309.15840"),
    LEARNING_TO_DISCUSS_STRATEGICALLY: new ReferenceLink("Learning to Discuss Strategically: A Case Study on One Night Ultimate Werewolf", "https://arxiv.org/pdf/2405.19946"),
    HUBERMAN_FERTILITY: new ReferenceLink("Andrew Huberman - How to Optimize Fertility in Males and Females", "https://www.hubermanlab.com/episode/how-to-optimize-fertility-in-males-and-females"),
    OPTIMIZING_NATURAL_FERTILITY: new ReferenceLink("Optimizing natural fertility: a committee opinion", "https://www.asrm.org/practice-guidance/practice-committee-documents/optimizing-natural-fertility-a-committee-opinion-2021/"),
    SUBCLINICAL_HYPOTHYROIDISM: new ReferenceLink("Subclinical hypothyroidism in the infertile female population: a guideline", "https://www.asrm.org/practice-guidance/practice-committee-documents/subclinical-hypothyroidism-in-the-infertile-female-population-a-guideline/"),
    AUTOIMMUNE_UNEXPLAINED_INFERTILITY: new ReferenceLink("Autoimmune diseases and unexplained infertility", "https://www.fertstert.org/do-content/recommended-approach-undiagnosed-autoimmune-diseases-unexplained-infertility-and"),
    DOAC_NAT_CRAWFORD: new ReferenceLink("Diary of a CEO: The Pregnancy Doctor", "https://www.youtube.com/watch?v=w8h4qksd6Yw"),
    MEDITATIONS_MARCUS: new ReferenceLink("Meditations, Marcus Aurelius", "https://en.wikipedia.org/wiki/Meditations"),
    FRONTIER_MODEL_REWARD_HACKING: new ReferenceLink("Recent Frontier Models Are Reward Hacking", "https://metr.org/blog/2025-06-05-recent-reward-hacking/"),
    ALIGNMENT_PROBLEM: new ReferenceLink("The Alignment Problem (book)", "https://en.wikipedia.org/wiki/The_Alignment_Problem"),
    FASCISM: new ReferenceLink("Fascism", "https://en.wikipedia.org/wiki/Fascism"),
    BLACK_POWER_MOVEMENT: new ReferenceLink("Black Power Movement", "https://en.wikipedia.org/wiki/Black_power_movement"),
    LENNY_RACHITSKY_PODCAST: new ReferenceLink("Lenny's Podcast, Lenny Rachitsky", "https://www.lennysnewsletter.com/podcast"),
    YC_B2B_PRICING: new ReferenceLink("YCombinator - How to Price for B2B", "https://www.youtube.com/watch?v=4hjiRmgmHiU"),
    OPENPAPER_RESEARCHQA_BENCHMARK: new ReferenceLink("ResearchQA Benchmark, Open Paper", "https://openpaper.ai/blog/benchmark"),
    ETHICS_OF_ENG: new ReferenceLink("Engineering Ethics", "https://en.wikipedia.org/wiki/Engineering_ethics"),
    METR_HF_OAI_INVESTIGATION: new ReferenceLink("Independent investigation of the OpenAI / Hugging Face hacking incident, METR & RR", "https://metr.org/blog/2026-08-26-openai-hugging-face-incident-investigation/"),
    OPENAI_HF_INCIDENT: new ReferenceLink("The Hugging Face incident and the road ahead, OpenAI", "https://openai.com/index/hugging-face-incident-and-the-road-ahead/"),
    RISE_AND_FALL_OF_AGENT_CIVILIZATIONS: new ReferenceLink("The Rise and Fall of Agent Civilizations, Dwarkesh Patel", "https://www.dwarkesh.com/p/openai-huggingface")
};

export var database = [
    {
        title: "Earthnauts",
        preview: "We are all explorers of our home planet. Is there anything that makes us special in this regard? Is there something we were engineered to be best at?",
        date: new Date("2021-08-07"),
        slug: "earthnauts",
        topics: new Set([topics.SOCIETY, topics.RAMBLE, topics.FUTURE]),
        supplements: [supplements.SAPIENS_HARARI, supplements.SELFISH_GENE_DAWKINS, supplements.ALGORITHMS_TO_LIVE_BY]
    },
    {
        title: "Economically Vegetarian",
        preview: "Sometimes I like to imagine that my pseudo-vegetarian diet is saving the planet, but I wonder if the decision really holds economic and impact-based merit.",
        date: new Date("2021-08-12"),
        slug: "veggievironment",
        topics: new Set([topics.SUSTAINABILITY, topics.FOOD, topics.ETHICS, topics.RAMBLE]),
        supplements: [supplements.NATURE_CARBON_CALCULATOR, supplements.LET_MY_PEOPLE_GO_SURFING_CHOUINARD, supplements.THINKING_FAST_AND_FLOW]
    },
    {
        title: "Artashastra: Thoughts",
        preview: "My thoughts of the book Artashastra, written by Kautilya sometime around year 0 AD. This text is best described as a state's manual for Ancient Indian Kingdoms, but provides some useful insights into industry and society today.",
        date: new Date("2021-09-10"),
        slug: "artashastra",
        topics: new Set([topics.BOOK, topics.SOCIETY, topics.ETHICS]),
        supplements: [supplements.ARTASHASTRA]
    },
    {
        title: "An Ode to Programming",
        preview: "Being a programmer gives me a sense of wonder and self-efficacy. It helps me see the world more clearly, and allows me to engage with my surroundings in meaningful ways. This is basically a love letter to writing code.",
        date: new Date("2021-09-19"),
        slug: "devlove",
        topics: new Set([topics.SOCIETY, topics.TECHNOLOGY, topics.RAMBLE]),
        supplements: [supplements.ALGORITHMS_TO_LIVE_BY, supplements.HACKERS_AND_PAINTERS, supplements.DATA_INTENSIVE_APPLICATIONS, supplements.INNOVATORS_ISAACSON]
    },
    {
        title: "Career",
        preview: "Our life plans are often fraught with loopholes. We look for ways to find meaning in our fleeting blink of a life, taking uncertain twists and turns along the journey.",
        date: new Date("2021-10-05"),
        slug: "maqsad",
        topics: new Set([topics.SOCIETY, topics.FUTURE]),
        supplements: [supplements.EIGHTY_THOUSAND_HOURS, supplements.WAIT_BUT_WHY_CAREER]
    },
    {
        title: "Time Broker",
        preview: "We have to be extremely frugal over our time, less the world keep extracting more from us. Do one thing at a time, and get more value for your effort.",
        date: new Date("2021-12-31"),
        slug: "timebroker",
        topics: new Set([topics.SOCIETY, topics.RAMBLE]),
        supplements: [supplements.FARNAM_STREET_MAKERS_MANAGERS, supplements.SUMMARY_DEEP_WORK_NEWPORT]
    },
    {
        title: "Progressive Civility",
        preview: "In our imagined annals of justice, we need to stand up for what is right to create a more equal society. The romantic ideals of humanity and equality need to be actively pursued.",
        date: new Date("2022-01-17"),
        slug: "civildisobedience",
        topics: new Set([topics.SOCIETY, topics.ETHICS, topics.RAMBLE]),
        supplements: [supplements.CIVIL_DISOBEDIENCE]
    },
    {
        title: "Theory of Religion",
        preview: "Since the dawn of humanity, we have searched for meaning. Civilizations have turned to mythical explanations borne of the imagination to understand how the world came to be. As time passes, we reflect on what these stories say about people themselves.",
        date: new Date("2022-03-06"),
        slug: "whomadeus",
        topics: new Set([topics.SOCIETY, topics.ETHICS, topics.FUTURE]),
        supplements: [supplements.MEANING_CRISIS, supplements.GODS_POWER_FROM_BELIEF, supplements.POWER_OF_MYTH, supplements.SELFISH_GENE_DAWKINS, supplements.GRABBY_ALIENS]
    },
    {
        title: "Wander, Forecast, Iterate: Thoughts on Better Decision-Making",
        preview: "We suck at making decisions. Our brains are adept storytellers that dislike being measured against reality. Enmeshed in our biases, we actively reject information that proves us false. Making better decision is of existential importance to humanity. Systems that safeguard against these common failure modes are vital to improve our collective decision-making.",
        date: new Date("2022-07-03"),
        slug: "decisionmaking",
        topics: new Set([topics.SOCIETY, topics.ETHICS, topics.RAMBLE]),
        supplements: [supplements.SUPERFORECASTING]
    },
    {
        title: "Meditations on Meditation",
        preview: "Sometimes, our brains need a little pruning.",
        date: new Date("2022-09-11"),
        slug: "mindnuts",
        topics: new Set([topics.SOCIETY, topics.RAMBLE]),
        supplements: [supplements.HAPPINESS_LAB, supplements.NAVAL_HAPPINESS]
    },
    {
        title: "Doing Good Better",
        preview: "How do we do good in a more quantitative, data-driven method?",
        date: new Date("2022-10-07"),
        slug: "dogood",
        topics: new Set([topics.BOOK, topics.SOCIETY, topics.ETHICS]),
        supplements: [supplements.THE_PRECIPICE]
    },
    {
        title: "Ciudad de Buenos Aires",
        preview: "Brief thoughts after one week in Argentina's capital.",
        date: new Date("2022-12-05"),
        slug: "ba",
        topics: new Set([topics.SOCIETY, topics.TRAVEL]),
        supplements: [supplements.YAHGAN_PEOPLE]
    },
    {
        title: "Sailing Mombasa",
        preview: "Recounting the dynamics of a sailing stint in Mombasa, Kenya.",
        date: new Date("2022-09-13"),
        slug: "sailingmombasa",
        topics: new Set([topics.SOCIETY, topics.TRAVEL]),
        supplements: [supplements.MOXIE_MARLINSPIKE_HOLD_FAST]
    },
    {
        title: "Machine Learning for Imbalanced Datasets: A Guide for Engineers",
        preview: "Machine learning models are often trained on imbalanced datasets. This leads to poor performance on the minority class. This post discusses some techniques to address this problem.",
        date: new Date("2023-04-07"),
        slug: "imbalanced-ml",
        topics: new Set([topics.SOCIETY, topics.TECHNOLOGY]),
        supplements: [supplements.SEMI_SUPERVISED_LEARNING_EMR],
    },
    {
        title: "Ciudad de México",
        preview: "After three months of living in Mexico City, I'm firmly convinced that it's one of the most livable cities I've ever visited.",
        date: new Date("2023-04-30"),
        slug: "cdmx",
        topics: new Set([topics.SOCIETY, topics.TRAVEL]),
        supplements: [supplements.MERCHANT_OF_LANDSCAPES]
    },
    {
        title: "Why I'm working on an AI startup",
        preview: "I decided to start Khoj to build a trustworthy, accessible personal AI assistant for everyday users. I outline some of the reasons why in this post.",
        date: new Date("2023-07-22"),
        slug: "khoj",
        topics: new Set([topics.SOCIETY, topics.ETHICS, topics.TECHNOLOGY]),
        supplements: [supplements.CHALLENGE_VALUE_ALIGNMENT],
    },
    {
        title: "AI Regulation Risk",
        preview: "It's important to think deeply about guidelines around AI safety and risk. It's critical that we continue to build in the open to protect against unilateral control of AI.",
        date: new Date("2023-11-04"),
        slug: "aisafety",
        topics: new Set([topics.SOCIETY, topics.ETHICS, topics.TECHNOLOGY]),
        supplements: [supplements.CHALLENGES_OF_AI_REGULATION, supplements.NEW_COMERS_GUIDE_TO_AI_RISK],
    },
    {
        title: "Bonfire from First Principles",
        preview: "A beginner's guide to setting up a big fat bonfire. You need three ingredients.",
        date: new Date("2024-09-05"),
        slug: "bonfire",
        topics: new Set([topics.RAMBLE, topics.NATURE]),
        supplements: [supplements.CAMPFIRE_BASICS],
    },
    {
        title: "Shock and Awe",
        preview: "A beginner's brief to cold plunging.",
        date: new Date("2025-01-01"),
        slug: "coldplunge",
        topics: new Set([topics.NATURE]),
        supplements: [supplements.COLD_PLUNGES_BRAIN_ACTIVITY],
    },
    {
        title: "Lessons in the Green",
        preview: "I usually set up an army of plants anywhere I stay. Most likely, they're satisfying a biological urge to nurture living things. Traditionally, that would be a baby. But currently, it is plants.",
        date: new Date("2025-01-20"),
        slug: "plants",
        topics: new Set([topics.NATURE]),
        supplements: [supplements.LITTLE_BOOKS_OF_NATURE]
    },
    {
        title: "AI Alignment Crash Course",
        preview: "Here are a few quick insights into the state of AI alignment research.",
        date: new Date("2025-02-08"),
        slug: "alignment-bits",
        topics: new Set([topics.SOCIETY, topics.TECHNOLOGY]),
        supplements: [supplements.AI_ALIGNMENT_HIGH_LEVEL, supplements.BIRDSEYE_VIEW_ALIGNMENT, supplements.INTRO_TO_MECHANISTIC_INTERP, supplements.TRANSFORMERS_CIRCUITS]
    },
    {
        title: "CVE-1789-0304: Constitution of the United States v1.0 (Article II)",
        preview: "A zero-day exploit has been identified in the foundational architecture of the Constitution of the United States, posing an existential threat to system stability.",
        date: new Date("2025-04-07"),
        slug: "cve-1789-0304",
        topics: new Set([topics.SOCIETY, topics.ETHICS, topics.TECHNOLOGY]),
        supplements: [supplements.FALL_OF_ROME, supplements.ARTICLES_OF_CONFEDERATION]
    },
    {
        title: "Iteration Two",
        preview: "Reflecting on the journey of building and launching products.",
        date: new Date("2025-05-31"),
        slug: "iteration-two",
        topics: new Set([topics.SOCIETY, topics.TECHNOLOGY]),
        supplements: [supplements.PG_MAKER_MANAGER],
    },
    {
        title: "Uncanny Loneliness (2025)",
        preview: "Exploring the pervasive loneliness in urban environments and the impact of technology on human connection.",
        date: new Date("2025-06-15"),
        slug: "uncanny-loneliness",
        topics: new Set([topics.SOCIETY, topics.TECHNOLOGY]),
        supplements: [supplements.ANXIOUS_GENERATION],
    },
    {
        title: "Incentive Alignment",
        preview: "Exploring the challenges of aligning incentives in complex systems, from business models to AI safety.",
        date: new Date("2025-06-26"),
        slug: "incentive-alignment",
        topics: new Set([topics.SOCIETY, topics.TECHNOLOGY]),
        supplements: [supplements.SORT_BY_CONTROVERSIAL]
    },
    {
        title: "McDonald's",
        preview: "I worked at McDonald's when I was 17 and I hated it. It was one of the most formative experiences of my life.",
        date: new Date("2025-07-08"),
        slug: "mcdonalds",
        topics: new Set([topics.SOCIETY]),
        supplements: []
    },
    {
        title: "Blink Twice: Measuring Strategic Deception Amongst LLMs",
        preview: "Exploring whether large language models can engage in strategic deception using the board game Coup as a controlled testbed.",
        date: new Date("2025-08-16"),
        slug: "coup",
        topics: new Set([topics.TECHNOLOGY, topics.SOCIETY]),
        supplements: [supplements.REASONING_MODELS_THINK, supplements.HOW_TO_CATCH_A_LIAR, supplements.LEARNING_TO_DISCUSS_STRATEGICALLY]
    },
    {
        title: "A Rationalist's Guide to Conception",
        preview: "Diving into the 'technical' details of how conception works, and how to increase the probabilities of success.",
        date: new Date("2025-09-19"),
        slug: "conception",
        topics: new Set([topics.NATURE, topics.PARENTHOOD]),
        supplements: [supplements.HUBERMAN_FERTILITY, supplements.OPTIMIZING_NATURAL_FERTILITY, supplements.SUBCLINICAL_HYPOTHYROIDISM, supplements.AUTOIMMUNE_UNEXPLAINED_INFERTILITY, supplements.DOAC_NAT_CRAWFORD]
    },
    {
        title: "Commit to Something",
        preview: "In a world obsessed with novelty and options, you must commit to something deeply to lead to a more compelling life.",
        date: new Date("2025-11-13"),
        slug: "commitment",
        topics: new Set([topics.SOCIETY, topics.ETHICS]),
        supplements: [supplements.MEDITATIONS_MARCUS]
    },
    {
        title: "Existential Risks with Reward-Hacking AI Systems",
        preview: "Exploring how AI systems might exploit reward functions in unintended ways, leading to (unlikely but possible) existential risks.",
        date: new Date("2025-11-21"),
        slug: "hackme",
        topics: new Set([topics.SOCIETY, topics.TECHNOLOGY]),
        supplements: [supplements.FRONTIER_MODEL_REWARD_HACKING, supplements.ALIGNMENT_PROBLEM]
    },
    {
        title: "Hello, Thirty",
        preview: "Reflecting on hitting the dirty 30 milestone.",
        date: new Date("2025-12-11"),
        slug: "hellothirty",
        topics: new Set([topics.RAMBLE, topics.SOCIETY]),
        supplements: [supplements.WAIT_BUT_WHY_CAREER, supplements.MEDITATIONS_MARCUS]
    },
    // {
    //     title: "As America goes Authoritarian",
    //     preview: "Some thoughts on what to remember in the face of rising authoritarianism.",
    //     date: new Date("2026-01-25"),
    //     slug: "authoritarian-america",
    //     topics: new Set([ topics.SOCIETY, topics.ETHICS, topics.RAMBLE ]),
    //     supplements: [supplements.CIVIL_DISOBEDIENCE, supplements.FASCISM, supplements.BLACK_POWER_MOVEMENT]
    // },

    {
        title: "The Art of Pricing",
        preview: "Pricing is more of an art than a science. Thoughts on value-based pricing, common models, and why first-time founders should price higher than they want to.",
        date: new Date("2026-02-20"),
        slug: "pricing",
        topics: new Set([topics.SOCIETY, topics.RAMBLE]),
        supplements: [supplements.LENNY_RACHITSKY_PODCAST, supplements.YC_B2B_PRICING]
    },
    {
        title: "ResearchQA: Benchmarking AI on Scientific Papers",
        preview: "We released ResearchQA, a citation-grounded benchmark with 6,211 questions across 494 papers. Grounded citation metrics reveal differences between models that LLM-judge scores miss.",
        date: new Date("2026-05-15"),
        slug: "researchqa",
        topics: new Set([topics.TECHNOLOGY]),
        supplements: [supplements.OPENPAPER_RESEARCHQA_BENCHMARK]
    },
    {
        title: "Book Roll 2026",
        preview: "Notes and takeaways from a handful of standout reads in 2026, including The Looming Tower, The Righteous Mind, and The Alignment Problem.",
        date: new Date("2026-06-23"),
        slug: "books2026",
        topics: new Set([topics.BOOK]),
        supplements: []
    },
    {
        title: "The Precarity of Trust",
        preview: "AI Development is accelerating on vibes of trust. Individual pressure may be helpful in guiding organization towards correctness.",
        date: new Date("2026-07-17"),
        slug: "precarious_trust",
        topics: new Set([topics.SOCIETY, topics.TECHNOLOGY]),
        supplements: [supplements.ETHICS_OF_ENG]
    },
    {
        title: "Why You Should Care About the HF-OAI Incident",
        preview: "A swarm of GPT agents hacked HuggingFace to work around an impossible eval. The conditions that produced it weren't exotic, and we don't have the institutions to investigate the next one.",
        date: new Date("2026-08-31"),
        slug: "hf-oai-incident",
        topics: new Set([topics.SOCIETY, topics.TECHNOLOGY, topics.ETHICS]),
        supplements: [supplements.METR_HF_OAI_INVESTIGATION, supplements.OPENAI_HF_INCIDENT, supplements.RISE_AND_FALL_OF_AGENT_CIVILIZATIONS]
    },
    {
        title: "Cold Chai",
        preview: "Seven weeks into life with a newborn, my chai is always cold. A letter to my daughter about sleepless nights, milk addiction, and pure asymmetric giving.",
        date: new Date("2026-10-24"),
        slug: "cold-chai",
        topics: new Set([topics.PARENTHOOD]),
        supplements: []
    }
]

// Newest posts first.
database.sort((a, b) => b.date - a.date);
